var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19437_2227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9087 2.27716H17.9287V0.380026C17.9287 0.249597 17.822 0.142883 17.6916 0.142883H16.0316C15.9012 0.142883 15.7945 0.249597 15.7945 0.380026V2.27716H8.20591V0.380026C8.20591 0.249597 8.09919 0.142883 7.96876 0.142883H6.30877C6.17834 0.142883 6.07162 0.249597 6.07162 0.380026V2.27716H1.09164C0.566958 2.27716 0.143066 2.70106 0.143066 3.22573V22.9085C0.143066 23.4332 0.566958 23.8571 1.09164 23.8571H22.9087C23.4334 23.8571 23.8573 23.4332 23.8573 22.9085V3.22573C23.8573 2.70106 23.4334 2.27716 22.9087 2.27716ZM21.723 21.7228H2.27735V10.4586H21.723V21.7228ZM2.27735 8.44287V4.41145H6.07162V5.8343C6.07162 5.96473 6.17834 6.07144 6.30877 6.07144H7.96876C8.09919 6.07144 8.20591 5.96473 8.20591 5.8343V4.41145H15.7945V5.8343C15.7945 5.96473 15.9012 6.07144 16.0316 6.07144H17.6916C17.822 6.07144 17.9287 5.96473 17.9287 5.8343V4.41145H21.723V8.44287H2.27735Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19437_2227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.654d19b1.svg";
export { ForwardRef as ReactComponent };